import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/API/api.service';
import * as CryptoJS from 'crypto-js';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  categoryID: any
  vendors: any
  categories: any
  categoryName = ''
  currentStatus: any

  constructor(private url: ActivatedRoute,private router: Router,private api: ApiService,private encrypt: EncryptionService) { }

  ngOnInit(): void {
    if(this.url.snapshot.params['id']){
      this.categoryID = this.url.snapshot.params['id'];
      this.categoryName = this.url.snapshot.params['catName']
      // this.categoryID = this.decodeHash(this.categoryID)
      console.log(this.categoryID)
    }

    if(this.categoryID){
      this.api.allVendorsForSpecificCategory(this.categoryID).subscribe({
        next: (response: any) => {
          this.vendors = response.data.data
          this.vendors.map((vendor: any) => {
            vendor.hashedId = this.generateHash(vendor.id.toString());
          });
          // if(this.vendors?.current_status?.is_open == false){
          //   this.currentStatus = "مغلق"
          // }else{
          //   if(this.vendors?.status == 'closed'){
          //     this.currentStatus = "مغلق"
          //   }else if(this.vendors?.status == 'busy'){
          //     this.currentStatus = "مشغول"
          //   }else{
          //     this.currentStatus = "مفتوح"
          //   }
          // }
          console.log(this.vendors)
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
      // this.api.subCategories(this.categoryID).subscribe({
      //   next: (response: any) => {
      //     this.subCategories = response.data
      //     // console.log(this.subCategories)
      //   }, error: (error: HttpErrorResponse) => {
      //     console.log(error)
      //   }
      // })
      // const formData = new FormData();
      // formData.append('type', 'categories');
      // formData.append('key', this.categoryName);
      // this.api.allVendors(formData).subscribe({
      //   next: (response: any) => {
      //     console.log(response.data.data)
      //   }, error: (error: HttpErrorResponse) => {

      //   }
      // })
    }else{
      this.api.categories().subscribe({
        next: (response: any) => {
          this.categories = response.data
          this.categories.map((category: any) => {
            category.hashedId = this.generateHash(category.id.toString());
          });
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }

  trackById(item: any): number {
    return item.id;
  }

  sendImage(image: string,vendorName: string){
    sessionStorage.setItem('categoryImage',image)
    sessionStorage.setItem('vendorName',vendorName)
    localStorage.setItem('categoryImage',image)
  }

  decodeHash(hashedId: string): string | null {
    return this.encrypt.decryptionAES(hashedId);
  }

  generateHash(id: string): string {
    return this.encrypt.encryptionAES(id)
  }
}
